import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const EDIT_OBJECT_EDITOR_SKELETON_ITEMS_COUNT = 8

export const EditObjectEditorSkeleton = () => (
  <Paper
    padding={[12]}
    radius="16px"
    className={s.card}
  >
    {Array.from({ length: EDIT_OBJECT_EDITOR_SKELETON_ITEMS_COUNT }).map(
      (_, index) => (
        <div
          key={index}
          className={s.item}
        >
          <Skeleton
            className={s.icon}
            borderRadius={8}
          />

          <div className={s.content}>
            <div className={s.text}>
              <Skeleton
                className={s.title}
                borderRadius={6}
              />
              <Skeleton
                className={s.subtitle}
                borderRadius={6}
              />
            </div>

            <Skeleton
              className={s.action}
              borderRadius={6}
            />
          </div>
        </div>
      ),
    )}
  </Paper>
)
